<template>
  <div class="introduce-meeting-platform">
    <div class='introduce-top'>
      <div>
        <p class='product-desc'>专业的医学学术会议直播互动解决方案</p>
        <img class='banner' src='../assets/introduce/meetingPlatform/image1.png'/>
      </div>
    </div>
    <div class='introduce-main'>
      <h2 class='title'>六大特色，共同打造一场专业级线上医学学术会议</h2>
      <div class='features'>
        <div v-for='(feature, index) in features'
          :key='index'
          class='feature-item'>
          <div>
            <div class='label'>{{feature.label}}</div>
            <div class='desc'>
              <p>{{feature.desc}}</p>
            </div>
          </div>
          <div class='image'>
            <img :style='`height: ${feature.imageHeight}px`' :src='feature.image'/>
          </div>
        </div>
      </div>
      <h2 class='title'>特色功能点</h2>
      <div class='feature-points'>
        <div v-for='(point, index) in featurePoints'
          :key='index'
          class='point-item'>
          <img class='image' :src='point.image' :style='`width: ${point.imageWidth}px`'/>
          <img class='hover-image' :src='point.hoverImage' :style='`width: ${point.imageWidth}px`'/>
          <div class='point-name'>{{point.name}}</div>
        </div>
      </div>
      <h2 class='title'>他们都在选择“马兰头医学会议平台”</h2>
      <div class='organitions'>
        <div v-for='(org, index) in organitions'
          :key='index'
          :class='{"organition-item": true, "longer-name": org.longerName}'>
          <div class='org-logo'>
            <img :src='org.logo' :style='`width: ${org.logoWidth}px`'/>
          </div>
          <div class='org-name'>{{org.name}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      features: [
        {
          label: '线上直播互动',
          desc: '最高支持36路视频同时接入，支持专家/嘉宾互动加入、观众文字提问。',
          image: require('../assets/introduce/meetingPlatform/image2.png'),
        },
        {
          label: '专属学分通道',
          desc: '支持学分通道登陆观看，自助积累学分。',
          image: require('../assets/introduce/meetingPlatform/image3.png'),
        },
        {
          label: '最高4K清晰度直播',
          desc: '马兰头多方融合视频引擎、音视频质量达到业界领先水平。支持4K，60帧高清音画直播。',
          image: require('../assets/introduce/meetingPlatform/image4.png'),
        },
        {
          label: '支持录播，内容沉淀，一键转换专业学习课程',
          desc: '支持会议录播，沉淀会议培训课程、资料，支持点播教学。学者可随时登录观看，更可统计学习时长。',
          image: require('../assets/introduce/meetingPlatform/image5.png'),
        },
        {
          label: '专业的会议服务管家，一站式直播服务',
          desc: '会议助理功能，可操控演讲人权限和顺序，保证会议流程顺畅。技术护航，线上调控，现场执行一站式直播服务。',
          image: require('../assets/introduce/meetingPlatform/image6.png'),
          imageHeight: 356,
        },
        {
          label: '“广播级”手术直播',
          desc: '音视频同步直播，4K高清画质。保留精彩学术内容。弥补了手术空间局限，观摩人数有限，观看视野预期等传统模式的不足。',
          image: require('../assets/introduce/meetingPlatform/image7.png'),
          imageHeight: 363,
        },
      ],
      featurePoints: [
        {
          name: '直播互动',
          image: require('../assets/introduce/meetingPlatform/image8.png'),
          hoverImage: require('../assets/introduce/meetingPlatform/image8-1.png'),
        },
        {
          name: '点播教学',
          image: require('../assets/introduce/meetingPlatform/image9.png'),
          hoverImage: require('../assets/introduce/meetingPlatform/image9-1.png'),
        },
        {
          name: '桌面共享',
          image: require('../assets/introduce/meetingPlatform/image10.png'),
          hoverImage: require('../assets/introduce/meetingPlatform/image10-1.png'),
        },
        {
          name: '全终端支持',
          image: require('../assets/introduce/meetingPlatform/image11.png'),
          hoverImage: require('../assets/introduce/meetingPlatform/image11-1.png'),
        },
        {
          name: '数据分析',
          image: require('../assets/introduce/meetingPlatform/image12.png'),
          hoverImage: require('../assets/introduce/meetingPlatform/image12-1.png'),
        },
        {
          name: '品牌定制化',
          image: require('../assets/introduce/meetingPlatform/image13.png'),
          hoverImage: require('../assets/introduce/meetingPlatform/image13-1.png'),
          imageWidth: 50,
        },
      ],
      organitions: [
        {
          name: '中国医师协会',
          logo: require('../assets/introduce/meetingPlatform/image14.png'),
          logoWidth: 138,
        },
        {
          name: '黑龙江卫健委',
          logo: require('../assets/introduce/meetingPlatform/image15.png'),
          logoWidth: 144,
        },
        {
          name: '北京协和医院',
          logo: require('../assets/introduce/meetingPlatform/image16.png'),
          logoWidth: 91,
        },
        {
          name: '浙江省医学会',
          logo: require('../assets/introduce/meetingPlatform/image17.png'),
          logoWidth: 131,
        },
        {
          name: '浙江省中医药学会',
          logo: require('../assets/introduce/meetingPlatform/image18.png'),
          logoWidth: 145,
        },
        {
          name: '浙江省抗癌协会',
          logo: require('../assets/introduce/meetingPlatform/image19.png'),
          logoWidth: 139,
        },
        {
          name: '北京医师协会眼科分会',
          logo: require('../assets/introduce/meetingPlatform/image20.png'),
          logoWidth: 138,
          longerName: true,
        },
        {
          name: '浙江省新华医院',
          logo: require('../assets/introduce/meetingPlatform/image21.png'),
          logoWidth: 140,
        },
        {
          name: '费森尤斯卡比',
          logo: require('../assets/introduce/meetingPlatform/image22.png'),
          logoWidth: 113,
        },
        {
          name: '浙江省医疗数据产业研究会',
          logo: require('../assets/introduce/meetingPlatform/image23.png'),
          logoWidth: 78,
          longerName: true,
        },
        {
          name: '武田制药',
          logo: require('../assets/introduce/meetingPlatform/image24.png'),
          logoWidth: 124,
        },
        {
          name: '武田制药',
          logo: require('../assets/introduce/meetingPlatform/image25.png'),
          logoWidth: 135,
        },
      ],
    }
  },
}
</script>

<style lang="less" scoped>
.introduce-meeting-platform {
  .introduce-top {
    background-color: #000;
    color: #fff;
    position: relative;
    background: linear-gradient(90deg,rgba(9,13,25,1) 0%,rgba(23,31,59,1) 50%,rgba(8,11,21,1) 100%);
    >div {
      width: 1200px;
      margin: 0 auto;
      padding: 37px 0 62px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .product-desc {
      font-size: 36px;
      font-weight: 600;
      color: #ffffff;
      line-height: 50px;
      letter-spacing: -1px;
    }
    .banner {
      width: 535px;
      margin-left: 20px;
    }
  }
  .introduce-main {
    width: 1200px;
    margin-left: auto;
    margin-right: auto;
    .title {
      position: relative;
      text-align: center;
      font-size: 36px;
      font-weight: 600;
      color: #333333;
      line-height: 50px;
      letter-spacing: -1px;
      padding: 60px 0;
      &:after {
        content: '';
        position: absolute;
        width: 80px;
        height: 6px;
        background: #8da8ff;
        left: 50%;
        bottom: 45px;
        transform: translateX(-50%);
      }
    }
    .features {
      > div {
        margin-bottom: 60px;
        display: flex;
        align-items: center;
        .image {
          text-align: center;
        }
        >div {
          flex: 1;
          &:first-child {
            margin-right: 40px;
          }
        }
        .label {
          font-size: 36px;
          font-weight: 600;
          color: #333333;
          line-height: 50px;
          letter-spacing: -1px;
          margin-bottom: 16px;
        }
        .desc {
          font-size: 18px;
          font-weight: 400;
          color: #333333;
          line-height: 25px;
        }
        img {
          height: 350px;
        }
        &:nth-of-type(even) {
          flex-direction: row-reverse;
          >div:first-child {
            margin-right: 0;
            padding-left: 80px;
          }
          >div:last-child {
            margin-right: 40px;
          }
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    .feature-points {
      display: flex;
      flex-wrap: wrap;
      width: 1100px;
      margin: auto;
      .point-item {
        width: 300px;
        height: 180px;
        text-align: center;
        background: #ffffff;
        border-radius: 6px;
        box-shadow: 0px 2px 11px -4px rgba(168,190,251,0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        margin-bottom: 30px;
        transition: all;
        .point-name {
          margin-top: 25px;
          font-size: 18px;
          font-weight: 400;
          color: #333333;
          line-height: 25px;
        }
        .image, .hover-image {
          width: 60px;
          &.hover-image {
            display: none;
          }
        }
        &:hover {
          background: #4aa7ff;
          .point-name {
            color: #fff;
          }
          .image {
            display: none;
          }
          .hover-image {
            display: inline;
          }
        }
        &:not(:nth-of-type(3n)) {
          margin-right: 100px;
        }
      }
    }
    .organitions {
      display: flex;
      flex-wrap: wrap;
      width: 1085px;
      margin: 0 auto 45px;
      .organition-item {
        width: 150px;
        height: 150px;
        padding-bottom: 19px;
        border-radius: 6px;
        box-shadow: 0px 2px 11px 0px rgba(168,190,251,0.5);
        display: flex;
        flex-direction: column;
        margin-bottom: 34px;
        margin-right: 37px;
        &.longer-name {
          padding-bottom: 11px;
        }
        .org-logo {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .org-name {
          font-size: 18px;
          font-weight: 400;
          color: #333333;
          line-height: 25px;
          text-align: center;
        }
        &:nth-of-type(6n) {
          margin-right: 0;
        }
      }
    }
  }
}
</style>